import React from "react";
import { Hourglass } from "lucide-react";
import { cls } from "../ui";

const TONE = {
  OK: "bg-emerald-50 text-emerald-800 border-emerald-300",
  WARN: "bg-amber-50 text-amber-800 border-amber-300",
  OVER: "bg-red-700 text-white border-red-700",
  CLOSED: "bg-slate-100 text-slate-600 border-slate-300",
  CLOSED_OVER: "bg-slate-200 text-red-800 border-red-300",
};

export const TS_LABEL = { OK: "Within standard", WARN: "Approaching", OVER: "Past standard", CLOSED: "Disposed", CLOSED_OVER: "Disposed late" };

/** Compact case-age chip graded against the matching time standard (filing → disposition). */
export function TimeChip({ ts, testId, long = false }) {
  if (!ts) return null;
  const text = ts.status === "OVER" ? `OVER +${ts.over_by}d` : ts.status === "WARN" ? `${ts.days}d · due ${ts.breach_days}d` : ts.status === "CLOSED_OVER" ? `closed +${ts.over_by}d late` : ts.status === "CLOSED" ? `closed ${ts.days}d` : `${ts.days}d`;
  const title = ts.rule ? `${ts.rule}: warn ${ts.warn_days}d · standard ${ts.breach_days}d · filed ${ts.filed} (${ts.days} days)` : `No time standard configured · filed ${ts.filed}`;
  return (
    <span className={cls("inline-flex items-center gap-0.5 text-[9px] font-bold border px-1 leading-[13px] whitespace-nowrap", TONE[ts.status] || TONE.OK)} title={title} data-testid={testId} data-ts-status={ts.status}>
      <Hourglass className="w-2.5 h-2.5" /> {text}{long && ts.rule ? ` · ${ts.rule}` : ""}
    </span>
  );
}
